export default __webpack_public_path__ + "static/media/6.4b56fd1b.png";